(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_batter"] && !window.DesignMode) return;
  try {
    
// DOMが完全に読み込まれた後に関数を実行します。
document.addEventListener('DOMContentLoaded', () => {
  // 各要素をIDを使用して取得します。
  const batterBefore = document.getElementById('batterBefore'); // 投げる前のバッター画像
  const batterBefore2 = document.getElementById('batterBefore2'); // 投げる動作中のバッター画像1
  const batterBefore3 = document.getElementById('batterBefore3'); // 投げる動作中のバッター画像2
  const batterBefore4 = document.getElementById('batterBefore4'); // 投げる動作中のバッター画像3
  const batterAfter = document.getElementById('batterAfter'); // 投げた後のバッター画像
  const batterBall = document.getElementById('batterBall'); // ボールの画像
  const ballContainer = document.querySelector('.scrollBatter-ball'); // ボールを含むコンテナ
  let lastScrollPosition = 0; // 前回のスクロール位置を保存する変数
  let batterAfterVisible = false; // batterAfter画像が表示されているかどうかのフラグ

  // スクロールイベントが発生するたびに関数を実行します。
  window.addEventListener('scroll', () => {
    const scrollY = window.pageYOffset; // 現在のスクロール位置
    const windowHeight = window.innerHeight; // ウィンドウの高さ
    const sectionRect = document.getElementById('scrollBatter').getBoundingClientRect(); // セクションの位置とサイズ
    const sectionTop = window.scrollY + sectionRect.top; // セクションの上端の絶対位置
    const sectionBottomInView = scrollY + windowHeight - sectionTop; // セクションの下端がビューポート内に入る位置

    // 全てのバッター画像を非表示にします。
    batterBefore.style.display = 'none';
    batterBefore2.style.display = 'none';
    batterBefore3.style.display = 'none';
    batterBefore4.style.display = 'none';
    batterAfter.style.display = 'none';
  
    // スクロール位置に基づいて、どのバッター画像を表示するかを決定します。
    if (sectionBottomInView > 250 && sectionBottomInView <= 300) {
      batterBefore2.style.display = 'block';
    } else if (sectionBottomInView > 300 && sectionBottomInView <= 350) {
      batterBefore3.style.display = 'block';
    } else if (sectionBottomInView > 350 && sectionBottomInView <= 400) {
      batterBefore4.style.display = 'block';
    } else if (sectionBottomInView > 400) {
      batterAfter.style.display = 'block';
      batterAfterVisible = true; // batterAfter画像が表示されていることをフラグで示します。
    } else {
      batterBefore.style.display = 'block';
    }
  
    // ボールの表示と移動処理を実行します。
    if (sectionBottomInView > 400 && batterAfterVisible) {
      batterBall.style.display = 'block'; // ボールを表示
      const scrollRange = sectionRect.height; // スクロール範囲
      const scrolled = scrollY - (sectionTop - windowHeight); // スクロールされた距離
      const scrollFraction = (scrolled / scrollRange); // スクロール進捗の割合
      // ボールの移動距離を全体の50%に制限
      const ballMoveDistance = (ballContainer.offsetWidth - batterBall.offsetWidth) * 0.3;
      const ballLeft = scrollFraction * ballMoveDistance; // ボールの新しい位置
      batterBall.style.left = `${ballLeft}px`; // ボールを新しい位置に移動
    } else {
      // ボールを非表示にし、初期位置にリセットします。
      batterBall.style.display = 'none';
      batterBall.style.left = `0px`;
      batterAfterVisible = false; // batterAfterの表示フラグをリセット
    }

    lastScrollPosition = scrollY; // スクロール位置を更新
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_collapsible-content"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var hiddenRows = document.querySelectorAll('.js-hidden-row'); // 隠されている行を全て選択
    var moreButton = document.querySelector('.js-more-button'); // もっと見るボタンを選択

    // もし隠された行が3つ以上あればボタンを表示
    if (hiddenRows.length > 3) {
        moreButton.style.display = 'block';
    } else {
        moreButton.style.display = 'none'; // それ以外の場合はボタンを非表示にする
    }

    // もっと見るボタンのクリックイベントハンドラ
    if (moreButton) {
        moreButton.addEventListener('click', function() {
            hiddenRows.forEach(function(row) {
                row.style.display = 'block'; // すべての隠された行を表示
            });
            moreButton.style.display = 'none'; // ボタンを非表示にする
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_news"] && !window.DesignMode) return;
  try {
    
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

document.addEventListener("DOMContentLoaded", function() {
  const newsListContainer = document.querySelector('.news-list-container');
  const postLimit = parseInt(newsListContainer.dataset.postLimit, 10);

  const adjustArticleVisibility = debounce(function() {
    const isMobileViewport = window.matchMedia("(max-width: 768px)").matches;
    const articlesToShow = isMobileViewport ? 2 : postLimit;
    const articles = document.querySelectorAll(".news-list-item");

    // 設定に基づいて表示する記事の数を制御
    articles.forEach((article, index) => {
      article.style.display = (index < articlesToShow) ? "" : "none";
    });
  }, 250);

  // 初期表示とウィンドウサイズ変更時に記事表示数を調整
  adjustArticleVisibility();
  window.addEventListener("resize", adjustArticleVisibility);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
